import { Dispatch, SetStateAction } from "react";
import { Product, Status } from "@/types/product";
import { TableFilter } from "@/types/utils";
import { getRoutes } from "@/utils/helpers";
import storage, { ObjectKeys } from "@/utils/storage";
import { Table } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";

const useHeader = (
  table: Table<Product>,
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
) => {
  const navigate = useNavigate();
  const routes = getRoutes();

  const onAddProductClick = () => {
    navigate(routes.product());
  };

  const onStatusFilterClick = (status?: Status) => {
    const existingFilter = storage.getItem("products_filter") as TableFilter;
    const storageKey = "products_filter";

    if (status) {
      table.getColumn("status")?.setFilterValue(status);
      storage.setItem(storageKey as ObjectKeys, {
        ...existingFilter,
        status,
      });
    } else {
      table.getColumn("status")?.setFilterValue(status);
      if (Object.keys(existingFilter).length === 1) {
        storage.removeItem(storageKey);
      } else {
        delete existingFilter.status;
        storage.setItem(storageKey, existingFilter);
      }
    }
  };

  const onImportProductClick = () => {
    setIsModalOpen(true);
  };

  return {
    onAddProductClick,
    onStatusFilterClick,
    onImportProductClick,
  };
};

export { useHeader };
